import { ReactNode } from 'react';

export enum TemporaryAccessSetupSteps {
  SALES_ORDERS,
  USER,
}

export type TemporaryAccessSetupPageContext = {
  setStep: (value: TemporaryAccessSetupSteps) => void;
  setHeaderButton: (value: ReactNode) => void;
};
